<template>
    <div class="d-flex align-items-center input-wrapper"
         tabindex="0"
         ref="inputWrapper"
         v-bind:class="{ active: isInputWrapperActive }">
        <div class="flex-grow-1 mr-1">
            <input v-if="tag === 'input'"
                   v-bind="tagOptions"
                   v-model="valueInComponent"
                   v-on:focusin="isInputWrapperActive = true">
            <textarea v-if="tag === 'textarea'"
                      v-bind="tagOptions"
                      v-model="valueInComponent"
                      v-on:focusin="isInputWrapperActive = true">
            </textarea>
        </div>
        <button class="btn btn-sm btn-light border text-nowrap"
                v-on:click="save">
            <font-awesome-icon icon="save"></font-awesome-icon>
        </button>
    </div>
</template>

<script>
    export default {
        name: "FieldEditable",
        props: {
            "value": {
                type: String,
                default: "",
            },

            "tag": {
                type: String,
                default: "input",
            },

            "tagOptions": {
                type: Object,
                default: () => {}
            },
        },
        data () {
            return {
                isInputWrapperActive: false,
                valueCopy: "",
            };
        },
        computed: {
            valueInComponent: {
                get () {
                    if (this.valueCopy) {
                        return this.valueCopy;
                    }
                    return this.value;
                },
                set (val) {
                    this.valueCopy = val;
                },
            }
        },
        methods: {
            save () {
                this.$emit(
                    "input",
                    this.valueInComponent
                );
                this.deactivateWrapper();
            },

            deactivateWrapper () {
                this.valueCopy = "";
                this.isInputWrapperActive = false;
            },
        },
        mounted () {
            document.body
                .addEventListener(
                    "click",
                    (evt) => {
                        if (
                            this.$refs.inputWrapper &&
                            !this.$refs.inputWrapper.contains(evt.target)
                        ) {
                            this.deactivateWrapper();
                        }
                    }
                );
        },
    }
</script>

<style lang="scss" scoped>
    .input-wrapper {
        button {
            display: none;
        }

        input {
            transition: background-color 250ms ease;
        }

        &.active {
            button {
                display: block;
            }

            input {
                background-color: rgba(255, 255, 255, 1);
            }
        }
    }
</style>
